import axiosInstance from "../../routes/axiosConfig";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const CompanyAddressService = {
  createCompanyAddress: async (addressData) => {
    try {
      const response = await axiosInstance.post(
        `${API_BASE_URL}/companyAddress`,
        addressData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao criar endereço da empresa (filial):",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getCompanyAddressesByCompanyId: async (companyId) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}/companyAddress/byCompany/${companyId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        `Erro ao buscar filiais para a empresa com ID ${companyId}:`,
        error.response?.data || error.message
      );
      throw error;
    }
  },

  updateCompanyAddress: async (companyAddressData) => {
    try {
      const response = await axiosInstance.put(
        `${API_BASE_URL}/companyAddress`,
        companyAddressData
      );
      return response.data;
    } catch (error) {
      console.error(
        `Erro ao atualizar filial: ID no corpo do request`,
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getAllCompanyAddresses: async () => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}/companyAddress/all`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao buscar todas as filiais:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  deleteCompanyAddress: async (id) => {
    try {
      const response = await axiosInstance.delete(
        `${API_BASE_URL}/companyAddress/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(
        `Erro ao excluir filial com ID ${id}:`,
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default CompanyAddressService;
